import { TKeys } from './types'

export const it_it: Record<TKeys, string> = {
    ...require('./en-en').en_en, // TODO
    // General
    loading: 'Caricamento …',
    // SCREENS
    // SignIn
    signin_title: 'Accedi',
    signin_redirect_title: 'Verificare il tuo login e password',
    psw_placeholder_redirect: "",
    psw_placeholder: 'Confermare password',
    email_placeholder: 'Indirizzo email',
    language: 'Lingua',
    forgot_password: 'Dimenticato la password?',
    signup_hint: 'Non hai un account? Iscriviti',
    btn_signin: 'Accedi',
    // Intro
    // N-Ary sort
    my_profile: ' Le Mie Preferenze',
    btn_submit: 'Invia',
    btn_finish: 'Termina',
    hint_undo: `Sei sicuro di voler annullare l'ultima azione?`,
    // Global screen
    tip_quit: 'Sei sicuro di voler uscire?',
    // State screen // Tell us, what is your ideal work environment?
    intro_title: 'La felicità è la chiave del successo',
    intro_body: `Se ami ciò che fai e la squadra con cui lavori, avrai successo nella tua vita professionale.`,
    howto1_title: `Vedrai 2 dichiarazioni

    Clicca su quella che preferisci

    Questo richiederà solo 12 minuti.`,
    howto1_body: `Dovresti fare questo test in un ambiente tranquillo.`,
    award1_title: 'Ottimo lavoro!',
    award1_body: `In cima all'elenco seguente troverai ciò che consideri più importante nel tuo ambiente di lavoro ideale. Se lo desideri, puoi riordinare l'ordine delle dichiarazioni trascinandole e rilasciandole.`,
    award2_title: 'Hai superato più della metà!',
    award2_body: `Immergetevi nell'entusiasmo di scoprire il vostro ambiente di lavoro ideale! Le vostre dichiarazioni più importanti si trovano in cima a questo elenco. Provate l'emozione mentre le riordinate a vostro piacimento semplicemente trascinandole e rilasciandole! Il vostro spazio di lavoro dei sogni è a portata di mano!`,
    award3_title: 'Congratulazioni per la terza parte',
    award3_body: `Ci sei quasi! Il traguardo è in vista! Respira profondamente, dai il massimo in questi momenti finali e celebra l'incredibile risultato che ti aspetta. Ce la puoi fare! Finisci forte e lascia che la storia di successo si svolga!`,
    howto2_title: 'E ora le ultime domande - ±2 minuti',
    howto2_body: `Ti verranno poste ancora alcune domande. Dovrai scegliere il migliore o il peggiore tra alcune delle dichiarazioni che hai già classificato. Questo ci permette di unire tutte e tre le fasi della tua personalità`,
    title_rank: 'Nel mio ambiente di lavoro **IDEALE**',
    subtitle_rank_2: 'ciò che conta di più è …',
    subtitle_rank_n: ' Dove posizioneresti la seguente dichiarazione?',
    hint_reorder: 'Riordina come necessario, dal più importante al meno importante',
    hint_overview: 'Clicca qui sotto per vedere il riepilogo',
    hint_profile: ' Le mie preferenze attuali',
    hint_place_below: 'Posiziona la dichiarazione qui sotto',
    title_rank_bucket: 'Confronti finali',
    subtitle_rank_best: 'Questa volta, quale è il PIÙ importante per te?',
    subtitle_rank_least: 'Quale è il MENO importante per te?',
    subtitle_rank_reorder: 'Riordina dal PIÙ importante al MENO importante',
    title_thanks: 'Ottimo lavoro!',
    hint_thanks: 'Le tue preferenze sono state inviate con successo',
    title_error: 'Non possiamo inviare i tuoi dati',
    hint_error: 'Riprova più tardi …',
    hint_error_validation: 'Si è verificato un errore di convalida, riprova più tardi',
    hint_error_dup: 'Hai già inviato un rapporto precedente.',
    hint_confirm_round: 'Sei sicuro di voler confermare questo classifica?',
    retry_btn: 'Riprova',
    btn_to_overview: 'PANORAMICA',
    btn_to_bucket_x: 'BUCKET',
    btn_to_params: 'PARAMETRI',
    btn_open: 'APRI',
    btn_start: 'INIZIA',
    btn_confirm: 'CONFERMA',
    // btn_next: 'NEXT',
    btn_next: '>',
    btn_next_str: 'SUCCESSIVO',
    btn_next_round: 'PROSSIMO ROUND',
    // btn_prev: 'PREV',
    btn_prev: '<',
    btn_cancel: 'ANNULLA',
    // btn_back: 'BACK',
    btn_back: '<',
    btn_download: 'Scarica il tuo report',
    btn_quit: 'ESCI',
    // Comparisons
    pick_best: 'Quale è il PIÙ importante per te?',
    pick_worst: 'Quale è il MENO importante per te?',
    vs: 'O',
    // UI elements
    round: 'Round',
    stm: 'Dichiarazione',
    bucket: 'Bucket',
    axis_y: 'Numero di dichiarazioni',
    tip_saved: 'Salvato',
    top_scale_hint: 'Il **PIÙ** importante',
    bottom_scale_hint: 'Il **MENO** importante',
    pick_tip: 'Selezionato!',
    how_to_binary_title: 'Istruzioni',
    // values
    samen: 'Collaborazione',
    conf: 'Conformità',
    erken: 'Riconoscimento',
    zorg: 'Cura',
    gelijk: 'Uguaglianza e diversità',
    zelfsturing: 'Autonomia',
    macht: 'Potere',
    voorspelbaar: 'Prevedibilità',
    prestatie: 'Performance',
    zelfontplooi: 'Autosviluppo',
    duurzaam: 'Sostenibilità',
    integriteit: 'Integrità',
    innovatie: 'Innovazione',
    daadkracht: 'Forza',
    // 
    no_slug_error: `Assicurati di aver seguito il link corretto, in caso contrario contatta l'amministratore/assistenza`,
    unknown_error: 'Si è verificato un errore sconosciuto, riprova più tardi',
    invalid_credentials: 'Combinazione email/password non valida',
    // 360
    // TLTM scale
    lvl0: 'Si prega di selezionare',
    lvl1: 'Decisamente troppo poco',
    lvl2: 'Troppo poco',
    lvl3: 'Piuttosto troppo poco',
    lvl4: 'Quantità giusta',
    lvl5: `Un po' troppo`,
    lvl6: 'Troppo',
    lvl7: 'Decisamente troppo',
    lvlx1: '-3',
    lvlx2: '-2',
    lvlx3: '-1',
    lvlx4: 'Quantità giusta',
    lvlx5: '+1',
    lvlx6: '+2',
    lvlx7: '+3',
    // SCALE 10 lvlSC10x
    lvlSC10x00: 'Si prega di selezionare',
    lvlSC10x00e: '🤔',
    //
    lvlSC10x0e: '😫',
    lvlSC10x0nps: 'Mai',
    lvlSC10x0: 'Nullo',
    lvlSC10x1e: '😖',
    lvlSC10x1nps: 'MISSING',
    lvlSC10x1: 'Estremamente cattivo',
    lvlSC10x2e: '😣',
    lvlSC10x2nps: 'MISSING',
    lvlSC10x2: 'Molto cattivo',
    lvlSC10x3e: '😠',
    lvlSC10x3nps: 'MISSING',
    lvlSC10x3: 'Insufficiente',
    lvlSC10x4e: '🙁',
    lvlSC10x4nps: 'MISSING',
    lvlSC10x4: 'Cattivo',
    lvlSC10x5e: '😯',
    lvlSC10x5nps: 'MISSING',
    lvlSC10x5: 'Mediocre',
    lvlSC10x6e: '😐',
    lvlSC10x6nps: 'MISSING',
    lvlSC10x6: 'Medio',
    lvlSC10x7e: '🙂',
    lvlSC10x7nps: 'MISSING',
    lvlSC10x7: 'Buono',
    lvlSC10x8e: '😊',
    lvlSC10x8nps: 'MISSING',
    lvlSC10x8: 'Molto buono',
    lvlSC10x9e: '😃',
    lvlSC10x9nps: 'MISSING',
    lvlSC10x9: 'Eccellente',
    lvlSC10x10e: '😍',
    lvlSC10x10nps: 'Certamente',
    lvlSC10x10: 'Impeccabile',
    howto_360_title: `Come organizzazione diamo grande importanza ai valori, crediamo che sia essenziale sapere cosa vi rende davvero felici nel vostro ambiente di lavoro.`,
    howto_360_body: `Questo questionario è e rimarrà anonimo per la vostra dirigenza, che riceverà solo i risultati aggregati`,
    picker_360_title_workenv: "Nel mio attuale ambiente di lavoro …",
    picker_360_title_leadership: "Il mio responsabile diretto …",
    nps_title: "Consiglieresti a chiunque tu conosca di lavorare qui?",
    comment_title: 'Aggiungi un commento',
    comment_placeholder: 'Vi ringraziamo per qualsiasi feedback costruttivo su questa dichiarazione',
    comment_save: 'Salva e chiudi',
    comment_remaining: 'character(s) left',
    howto_workenv_title: 'And now, your work environment',
    howto_workenv_body: 'What about it ? Last questions, we promise!',
    howto_nps_title: "",
    howto_nps_body: "",
    // legacy_v2:
    btn_next_step: 'Avanti',
    to_assign: 'Da assegnare',
    least_important: 'Meno importante',
    moderately_important: 'Moderatamente importante',
    most_important: 'Più importante',
    ranker_title: 'Cosa è importante per te nel lavoro ideale?',
    too_insufficient_warning: 'Questo gruppo contiene un numero insufficiente di affermazioni',
    too_much_warning: 'Questo gruppo contiene troppe affermazioni',
    too_much_warning1: 'Hai assegnato troppe affermazioni ai seguenti gruppi:',
    too_much_warning2: 'Clicca sul gruppo e assegna le affermazioni a un altro gruppo fino a ottenere una distribuzione corretta',
    empty_bin: 'Questo gruppo è vuoto',
    // further_ranking: 'Per favore, classifica ulteriormente le {{v1}} affermazioni che hai indicato come "{{v2}}"',
    further_ranking: 'Cosa è importante per te nel lavoro ideale?',
    hint_modal_title: 'Immagina il tuo ambiente di lavoro ideale',
    hint_modal_body1: 'Classifica 42 affermazioni sul tuo ambiente ideale dal meno al più importante',
    hint_modal_body2_left: 'sinistra',
    hint_modal_body2_left_txt: 'le 11 affermazioni che ritieni meno importanti',
    hint_modal_body2_right: 'destra',
    hint_modal_body2_right_txt: 'le 11 affermazioni che ritieni più importanti',
    hint_modal_body2_middle: 'centro',
    hint_modal_body2_middle_txt: 'le 20 affermazioni che ritieni moderatamente importanti',
    hint_modal_body3: 'Trascina e rilascia ogni affermazione nel gruppo che ti si addice meglio',
    hint_modal_cta: 'Inizia',
    hint_top: 'Scorri verso l\'alto',
    hint_down: 'Scorri verso il basso',
    final_distribution_invalid_title: 'La distribuzione finale non è valida',
    final_distribution_invalid_body: 'Ci sono {{v1}} secchio/i con troppe dichiarazioni e {{v2}} secchio/i con troppo poche dichiarazioni',
    no_available_bins_warning: 'Nessun secchio disponibile per l\'assegnazione casuale - tutti i secchi sono alla massima capacità',
    sort_middle_bucket_title: 'Vuoi ordinare il secchio di mezzo?',
    sort_middle_bucket_body: 'Questo ordinerà il secchio di mezzo per valore.',
    reflect_current_view_title: 'Questo riflette la tua visione attuale?',
    reflect_current_view_sort_body: 'In caso contrario, ti verrà offerto di ordinare la tua classifica finale',
    yes: 'Sì',
    no: 'No',
    final_ranking: 'Classifica finale',
    example: 'Esempio :',
}